import { forwardRef } from 'react'
import Select from 'react-select'

export interface SelectOption {
    id: string
    value: string
}

interface SelectProps {
    label: string
    name: string
    placeholder?: string
    field: any
    errors?: any
    disabled?: boolean
    required?: boolean
    multiple?: boolean
    options: SelectOption[]
}

const FlexSelect = forwardRef<any, SelectProps>(
    (
        {
            label,
            name,
            placeholder = 'Select an option',
            field,
            errors = {},
            options,
            required = false,
            disabled = false,
        },
        ref
    ) => {
        const errorMessage = errors[name]?.message

        const customStyles = {
            control: (styles: any, { isFocused }: any) => ({
                ...styles,
                borderColor: isFocused ? '#2257BE' : styles.borderColor, // Change to primary color
                boxShadow: isFocused ? '0 0 0 1px #2257BE' : styles.boxShadow, // Change to primary color
                '&:hover': { borderColor: '#2257BE' }, // Change hover border color to primary color
                borderRadius: '0.375rem',
                minHeight: '2.2rem',
                fontSize: '0.9rem',
            }),
            menu: (styles: any) => ({
                ...styles,
                borderRadius: '0.375rem',
                fontSize: '0.9rem',
            }),
            option: (styles: any, { isFocused, isSelected }: any) => ({
                ...styles,
                backgroundColor: isFocused
                    ? 'rgba(34, 87, 190, 0.1)' // Lightened primary color for focus
                    : isSelected
                    ? 'rgba(34, 87, 190, 0.3)' // Darkened primary color for selection
                    : null,
                color: isSelected ? '#2257BE' : styles.color, // Change selected text color to primary color
            }),
        }

        const formattedOptions = options.map((opt) => ({ label: opt.value, value: opt.id }))

        return (
            <div className="">
                <label htmlFor={name} className="block text-base text-primary font-semibold mb-1">
                    {label}
                    {required && <span className="text-primary ml-1">*</span>}
                </label>
                <Select
                    ref={ref}
                    placeholder={placeholder}
                    options={formattedOptions}
                    isDisabled={disabled}
                    styles={customStyles}
                    onChange={(option: any) => field.onChange(option ? option.value : null)}
                    value={formattedOptions.find((opt) => opt.value === field.value) || null}
                    classNamePrefix="react-select"
                />
                {errorMessage && <span className="text-primary text-sm mt-1">{errorMessage}</span>}
            </div>
        )
    }
)

FlexSelect.displayName = 'FlexSelect'

export default FlexSelect
